import React, { useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid

import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import i18next from "i18next";

import { BSCoreServicesDtoMarketplaceNcpCompensationProductDetailDto } from "api/reactQuery/querySchemas";
import { COLUMN_TYPE_NAMES, getGridDefaultProps } from "constants/agGridConstants";
import { currencyFormatter } from "helpers/agGrid/valueFormatters";

type Props = {
  ncpData: BSCoreServicesDtoMarketplaceNcpCompensationProductDetailDto[];
};

const NcpCompensationTable = ({ ncpData }: Props) => {
  const colDefs = useMemo<ColDef<BSCoreServicesDtoMarketplaceNcpCompensationProductDetailDto>[]>(
    () => [
      {
        field: "importDate",
        headerName: i18next.t("ncp_compensation_table_import"),
        type: COLUMN_TYPE_NAMES.DATE_COLUMN,
      },
      {
        field: "ncpName",
        headerName: i18next.t("ncp_compensation_table_promo_name"),
      },
      {
        field: "productName",
        headerName: i18next.t("ncp_compensation_table_product"),
        valueFormatter: (params) => {
          if (params.value === "no products available") {
            return i18next.t("ncp_compensation_table_no_products");
          }
        },
      },
      {
        field: "importedNcpQuantity",
        headerName: i18next.t("ncp_compensation_table_bonus_quantity"),
      },
      {
        field: "remainingNcpQuantity",
        headerName: i18next.t("ncp_compensation_table_remaining_quantity"),
      },
      {
        field: "ncpPrice",
        headerName: i18next.t("ncp_compensation_table_price_without_VAT"),
        valueFormatter: (params) => currencyFormatter(params, 4, 4),
      },
    ],
    []
  );

  if (!ncpData) return null;

  return (
    <div style={{ height: 130, marginBottom: 80, marginTop: 30 }}>
      <h1 style={{ fontSize: 30 }}>{i18next.t("ncp_compensation")}</h1>
      <AgGridReact
        rowData={ncpData}
        columnDefs={colDefs}
        {...getGridDefaultProps()}
      />
    </div>
  );
};

export default NcpCompensationTable;
